import React, { useState } from 'react';
import styles from './FAQ.module.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: 'What is YetiDeals?',
      answer: 'YetiDeals is a Nepal-based multi-vendor e-commerce platform registered under Nepalese law (Company Act, 2063) where you can buy electronics, gadgets, fashion, and seasonal products online with full consumer protection as per the Electronic Transaction Act, 2063 and Consumer Protection Act, 2075.'
    },
    {
      question: 'What payment methods do you accept?',
      answer: `Currently, YetiDeals accepts Cash on Delivery (COD) for orders up to NPR 5,000.
      
      Why only COD for now?
      - To build customer trust in our platform
      - You pay only after receiving and verifying the product
      - No risk of online payment fraud during our initial phase
      
      Technical Note: 
      While we have fully integrated online payment systems (eSewa, Khalti, ConnectIPS, Cards), we have temporarily disabled them to focus on perfecting our delivery and customer service experience first.
      
      Coming Soon: 
      Online payments will be enabled once we establish consistent operations. The system is ready and tested - just waiting for the right time to launch!`
    },
    {
      question: 'How does Cash on Delivery (COD) work?',
      answer: `COD Terms & Conditions:
      1. Maximum COD limit: NPR 5,000 per transaction
      2. Payment only after verifying the product at delivery
      3. Must provide valid ID proof (Citizenship/Passport/Driving License)
      4. No partial payments accepted
      5. Delivery personnel will wait maximum 5 minutes for verification
      6. Please keep exact cash amount ready (change may not be available)
      
      Note: For orders above NPR 5,000, please contact customer support for special assistance.`
    },
    {
      question: 'What if my order total exceeds NPR 5,000?',
      answer: `Since we currently accept COD only up to NPR 5,000:
      
      Option 1: Split your order into multiple orders (each under NPR 5,000)
      
      Option 2: Remove some items to bring total under NPR 5,000
      
      Option 3: Contact our customer support for special consideration
      
      Option 4: Wait for our online payment system launch (coming soon)
      
      We apologize for this temporary limitation. The good news is our online payment system is already integrated and tested - we're just waiting for the right time to enable it!`
    },
    {
      question: 'Is online payment available?',
      answer: `Short answer: Not yet, but soon!
      
      Long answer: We have successfully integrated popular payment methods including:
      - eSewa
      - Khalti
      - ConnectIPS
      - Credit/Debit Cards (Visa/Mastercard)
      - QR Code payments
      
      However, we have chosen to launch with COD only to:
      1. Ensure smooth delivery operations first
      2. Build customer trust in our platform
      3. Train our delivery team properly
      4. Gather feedback before enabling online payments
      
      Rest assured: The moment we are confident in our operations, we will enable online payments immediately since the system is already in place and working.`
    },
    {
      question: 'Delivery Terms and Conditions',
      answer: `1. Delivery timeframe: 1-2 working days (Kathmandu Valley), 3-10 days (other regions)
      2. Remote areas may take additional 3-5 days
      3. Must provide exact GPS location or landmark for delivery
      4. Three delivery attempts will be made before order cancellation
      5. Free delivery on orders above NPR 3,000 (within Nepal)`
    },
    {
      question: 'Return/Refund Policy (Mandatory as per Consumer Protection Act)',
      answer: `Eligibility Criteria:
      1. Report issues within 24 hours of delivery via call/email
      2. Provide clear evidence (photos/videos with timestamp)
      3. Original packaging and tags must be intact
      4. Product must be unused and in original condition
      
      Non-Refundable Items:
      1. Perishable goods
      2. Software/PDFs/Digital products
      3. Personalized/custom-made items
      4. Products without original invoice
      
      Process:
      1. Refund initiated within 3 working days of approval
      2. Full refund for wrong/defective items
      3. Refund method: Cash or Bank transfer
      4. Pickup arranged for defective/wrong items`
    },
    {
      question: 'Product Warranty Terms',
      answer: `1. Warranty period varies by product category (3-12 months)
      2. Manufacturer warranty only covers manufacturing defects
      3. Physical damage/liquid damage void warranty
      4. Must present original invoice for warranty claims
      5. Warranty repairs may take 15-30 working days
      
      As per Nepal Standard (NS):
      - Electronics: Minimum 6 months
      - Appliances: Minimum 1 year
      - Mobile phones: 12 months (as per NTA directive)
      - No warranty on consumables/batteries/accessories`
    },
    {
      question: 'Legal Compliance for Sellers',
      answer: `1. Must be registered with PAN/VAT (Inland Revenue Department)
      2. Required to display actual business address
      3. Must comply with Black Money (Control) Act, 2072
      4. Product pricing must include all taxes
      5. Prohibited from selling restricted/illegal items
      6. Must confirm stock availability before accepting COD orders`
    },
    {
      question: 'Consumer Rights (As per Nepalese Law)',
      answer: `1. Right to accurate product information (Electronic Transaction Act Sec. 46)
      2. Right to inspect product before COD payment
      3. Right to cancel order before delivery
      4. Right to file complaint at Department of Commerce if unsatisfied
      5. Protection against misleading advertisements`
    },
    {
      question: 'Data Privacy (Privacy Act, 2075)',
      answer: `1. We never share customer data without consent
      2. All customer information is kept confidential
      3. Right to request data deletion
      4. All transactions logged as per Cyber Law, 2061
      5. Mandatory KYC for high-value transactions (>NPR 100,000)`
    },
    {
      question: 'Dispute Resolution Process',
      answer: `1. First attempt: Mediation with seller (within 7 days)
      2. Second step: YetiDeals arbitration (next 7 days)
      3. Final recourse: Consumer Court (as per Consumer Protection Act)
      4. All disputes governed by Nepalese law
      5. Jurisdiction: Jhapa District Court`
    },
    {
      question: 'Important Tax Regulations',
      answer: `1. 13% VAT applicable on all taxable goods
      2. All prices include VAT unless specified
      3. Tax invoice provided with every purchase
      4. Sellers must comply with IRD tax regulations
      5. Digital service tax applicable on platform fees (when applicable)`
    },
    {
      question: 'When will online payments be enabled?',
      answer: `The honest answer: We don't have an exact date yet, but we're working towards it!
      
      What's done:
      ✅ Online payment system fully integrated
      ✅ Payment gateway testing completed
      ✅ eSewa, Khalti, ConnectIPS ready
     
      
      What we're perfecting:
      🔄 Delivery operations
      🔄 Customer service response time
      🔄 Return/refund processes
      🔄 Vendor management
      
      Estimated timeline: Within 3-6 months, depending on how quickly we perfect our operations.
      
      Follow us on social media for the announcement when online payments go live!`
    }
  ];

  return (
    <div className={styles.faqContainer}>
      <h1>Frequently Asked Questions (FAQs)</h1>
      
      <div className={styles.legalNotice}>
        <strong>Legal Compliance Notice:</strong> This platform operates under:
        <ul>
          <li>Electronic Transaction Act, 2063</li>
          <li>Consumer Protection Act, 2075</li>
          <li>Company Act, 2063</li>
          <li>Privacy Act, 2075</li>
        </ul>
      </div>
      
      <div className={styles.urgentNotice}>
        <strong>Important Payment Information:</strong>
        <ol className={styles.noticeList}>
          <li>Currently accepting ONLY Cash on Delivery (COD) up to NPR 5,000</li>
          <li>Online payment system is READY but temporarily disabled (launching soon)</li>
          <li>Always verify products before COD payment</li>
          <li>Keep exact cash ready at delivery time</li>
          <li>Keep original packaging for 7 days</li>
          <li>Report issues within 24 hours with clear photos/videos</li>
          <li>Beware of fake calls/SMS - we NEVER ask for advance payment or OTP</li>
          <li>For orders above NPR 5,000, please contact customer support</li>
        </ol>
      </div>

      {faqs.map((faq, index) => (
        <div key={index} className={`${styles.faqItem} ${activeIndex === index ? styles.active : ''}`}>
          <h3 className={styles.faqQuestion} onClick={() => toggleFAQ(index)}>
            {faq.question}
          </h3>
          {activeIndex === index && (
            <div className={styles.faqAnswer}>
              {faq.answer.split('\n').map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  {i < faq.answer.split('\n').length - 1 && <br />}
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      ))}

      <div className={styles.grievance}>
        <h3>Grievance Redressal Mechanism</h3>
        <p>As mandated by Consumer Protection Regulation, 2076:</p>
        <ol>
          <li>Email: yetideals.np@gmail.com (Response within 72 hrs)</li>
          <li>Hotline: 9815014878 (10AM-5PM, Sun-Fri)</li>
          <li>Physical Complaint: YetiDeals Office, Birtamode, Jhapa</li>
          <li><strong>For COD issues or orders above NPR 5,000:</strong> Contact support before placing order</li>
        </ol>
      </div>
    </div>
  );
};

export default FAQ;
